import { render, staticRenderFns } from "./distributor.vue?vue&type=template&id=3e51004e&scoped=true&"
import script from "./distributor.vue?vue&type=script&lang=js&"
export * from "./distributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e51004e",
  null
  
)

export default component.exports